module.exports = __webpack_public_path__ + "a0ac9163ff50fb456d0f0b4088a3bf8f.svg";